export default __webpack_public_path__ + "static/media/7.dd636040.jpg";